<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 131.35 503.5"
    class="svg-icon"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <circle class="cls-1" cx="65.67" cy="65.67" r="65.67" />
        <circle class="cls-1" cx="65.67" cy="251.75" r="65.67" />
        <circle class="cls-1" cx="65.67" cy="437.83" r="65.67" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "IconDots"
};
</script>
